// ======================================================================
// File Name       : EmailList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Table, Col } from 'react-bootstrap';
import { mailSendStatusType } from '../../constants/EmailConstants';
import ReduxFormPaging from '../ReduxFormPaging';
import PaginationCustom from '../../components/Pagination';
import CustomLink from '../../components/button/CustomLink';
import * as ICON from '../../constants/IconConstants';

class EmailList extends React.Component {

  showDetail(emailInfo) {
    this.props.onDetailClick(emailInfo);
  }

  render() {
    const { mailList, handleSortState, invalid, getStartEndData, recordNum, startPosition } = this.props;
    const thead = [
      { title: 'ユーザー名', sortBy: 0 },
      { title: 'グループ名', sortBy: null },
      { title: '件名', sortBy: 1 },
      { title: '送信日時', sortBy: 3},
      { title: '送信結果', sortBy: 2},
      { title: '操作', sortBy: null, width: 100 },
    ];
    let tbody = null;
    const changeMailStatus = (type) => {
      try {
        const statusValue = parseInt(type, 10);
        return mailSendStatusType[statusValue].name;
      } catch (error) {
        return type;
      }
    };
    if (mailList && mailList.length) {
      tbody = mailList.map((mail, index) => {
        const {
          receiverUserName,
          receiverUserGroupNames,
          emailTitle,
          emailSendDate,
          emailSendStatus,
        } = mail;
        return (
          <tr key={index} onMouseEnter={() => this.props.handleMouseEnter(index)} onMouseLeave={() => this.props.handleMouseLeave()}>
            <td>{receiverUserName}</td>
            <td>{receiverUserGroupNames}</td>
            <td>{emailTitle}</td>
            <td>{emailSendDate}</td>
            <td>{changeMailStatus(emailSendStatus)}</td>
            <td className="text-center text-nowrap">
              <CustomLink
                className="margin-right-7 link-detail"
                onClick={this.showDetail.bind(
                  this,
                  mail,
                )}
                text="詳細を見る"
              />
            </td>
          </tr>
        );
      });
    }
    return (
      <div>
        <Table striped hover>
          <thead>
            <ReduxFormPaging
              type="tableHead"
              data={thead}
              name="emailSortType"
              invalid={invalid}
              handleSortState={handleSortState}
            />
          </thead>
          <tbody>{tbody}</tbody>
        </Table>
        <Col sm={12} className="text-center">
          <ReduxFormPaging
            type="paging"
            name="startPosition"
            recordNum={recordNum}
            getStartEndData={getStartEndData}
          />
        </Col>
      </div>
    );
  }
}

export default EmailList;
